import { render } from "./old.vue?vue&type=template&id=83322bfc&ts=true"
import script from "./old.vue?vue&type=script&lang=ts"
export * from "./old.vue?vue&type=script&lang=ts"

import "./old.vue?vue&type=style&index=0&id=83322bfc&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__